import { Mail, Phone, MapPin, Clock, MessageCircle } from "lucide-react";
import { Reveal } from "@/lib/motion";
import InquiryForm from "@/components/InquiryForm";
import { CONTACT, IMAGES } from "@/lib/data";

const DETAILS = [
  { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
  { icon: Phone, label: "Phone", value: CONTACT.phone, href: `tel:${CONTACT.phone}` },
  { icon: MessageCircle, label: "WhatsApp", value: CONTACT.phone, href: `https://wa.me/${CONTACT.whatsapp}` },
  { icon: MapPin, label: "Address", value: CONTACT.address, href: null },
  { icon: Clock, label: "Working Hours", value: CONTACT.hours, href: null },
];

export default function Contact() {
  return (
    <main className="bg-beige" data-testid="contact-page">
      <section className="relative pt-40 pb-20 bg-forest text-beige overflow-hidden grain">
        <img src={IMAGES.cargo} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-t from-forest to-forest/70" />
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <p className="overline text-gold mb-4">Get in Touch</p>
          <h1 className="font-serif text-6xl md:text-7xl leading-none">Let's begin a<br /><span className="italic text-gold">conversation.</span></h1>
          <p className="mt-6 text-beige/75 font-light max-w-xl text-lg">
            Share your requirement and our export desk responds within 24 hours with pricing, samples and documentation guidance.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <Reveal><p className="overline text-olive mb-6">Reach Our Export Desk</p></Reveal>
          <div className="space-y-7">
            {DETAILS.map((d, i) => {
              const Icon = d.icon;
              const inner = (
                <div className="flex items-start gap-5 group" data-testid={`contact-${d.label.toLowerCase().replace(" ", "-")}`}>
                  <div className="w-12 h-12 rounded-full bg-olive/10 flex items-center justify-center shrink-0 group-hover:bg-gold transition-colors duration-500">
                    <Icon className="w-5 h-5 text-olive group-hover:text-forest transition-colors duration-500" />
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-widest text-forest/50 mb-1">{d.label}</p>
                    <p className="text-forest font-medium text-lg">{d.value}</p>
                  </div>
                </div>
              );
              return (
                <Reveal key={d.label} delay={i * 0.06}>
                  {d.href ? <a href={d.href} target={d.label === "WhatsApp" ? "_blank" : undefined} rel="noreferrer">{inner}</a> : inner}
                </Reveal>
              );
            })}
          </div>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <div className="bg-white p-8 md:p-12 rounded-2xl shadow-[0_20px_60px_-30px_rgba(27,59,54,0.4)]">
              <h2 className="font-serif text-3xl md:text-4xl text-forest mb-8">Request a Quote</h2>
              <InquiryForm variant="light" />
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
